import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyGoogleRankingPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** Every agency member may view it (the parent layout gates non-agency users; the API scopes salons). */
export const Route = createFileRoute('/_auth/agency/google-ranking')({
  component: AgencyGoogleRankingRoute,
});

function AgencyGoogleRankingRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Google Ranking')}</title>
      </Helmet>
      <AgencyGoogleRankingPage />
    </>
  );
}
